import { render, staticRenderFns } from "./FlatHeader.vue?vue&type=template&id=25354bd7&scoped=true"
import script from "./FlatHeader.vue?vue&type=script&lang=js"
export * from "./FlatHeader.vue?vue&type=script&lang=js"
import style0 from "./FlatHeader.vue?vue&type=style&index=0&id=25354bd7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25354bd7",
  null
  
)

export default component.exports